import {
  Component,
  ViewChild,
  OnInit,
  ChangeDetectionStrategy
} from "@angular/core";
import { getApp } from "../app";
import { Type } from "../../../../shared/components";
import { getBomPartEntry } from "../../../../shared/models/part";
import { Responsibles } from "../../../../shared/models/responsibles";
import { Customer } from "../../../../shared/types/customers";

@Component({
  selector: "app-import",
  templateUrl: "./import.component.html",
  styleUrls: ["./import.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ImportComponent implements OnInit {
  step: "first" | "second" | "third" | "fourth" | "fifth" | "error" = "first";
  fileType: string = "excel";
  type: Type | null = null;
  types: Type[] | any = [];
  deletingType: Type = "part";
  showDataTypeDropdown = false;
  showExcelFileBtn = true;
  excelSelected = false;
  jsonSelected = false;
  fileExtension = "";

  app = getApp((app) => {
    this.app = app;
  });

  constructor() {}

  ngOnInit(): void {
    sessionStorage.removeItem("fileUpload");
    // to be uncommented when the import will work for all types
    this.types = [
      "part",
      "manufacturer",
      "assembly",
      "thread",
      "dinCodeResponsible",
      "commodityGroupResponsible",
      "alert",
      "message",
      "all-config",
      "vehicleResponsible",
      "productCategory",
      "manufacturerCode",
      "warehouseGroup"
    ];
    if (this.app.state.isRMAdmin || this.app.auth.isTeam) {
      this.types = ["part", "manufacturer", "assembly"];
    }
    if (this.app.customers.expectCurrent === Customer.TTI) {
      this.types.push("manufacturerResponsibles", "productTypeResponsibles");
    }

    // TODO: change this after the bussines manager flag will be implemented
    if (
      (this.app.customers.expectCurrent === Customer.RHEINMETALLAIRDEFENCE ||
        this.app.customers.expectCurrent === Customer.RHEINMETALLITALY ||
        this.app.customers.expectCurrent === Customer.RWM) &&
      this.app.state.businessManager
    ) {
      this.types = ["part", "manufacturer", "assembly", "warehouseGroup"];
    }

    this.app.import.step = "first";

    this.app.import.duplicatedItems = [];
  }

  chooseFileType(type: string) {
    this.app.import.step = "first";
    this.fileType = type;
    if (type === "excel") {
      this.fileExtension =
        ".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet .csv'";
      this.showDataTypeDropdown = true;
      this.showExcelFileBtn = false;
      this.excelSelected = true;
      this.jsonSelected = false;
      this.types = this.types.filter((item: string) => item !== "all-config");
    }
    if (type === "json") {
      this.fileExtension = ".json, application/json";
      this.showDataTypeDropdown = false;
      this.showExcelFileBtn = true;
      this.excelSelected = false;

      this.jsonSelected = true;
      this.app.import.type = "all-config";
    }
  }

  getLabel(type: any) {
    if (type === "assembly") {
      return this.app.text.import.structure;
    }
    if (type === "productCategory") {
      return this.app.text.productCategory.productCategory;
    }
    if (type === "all-config") {
      return "All configuration data";
    }
    if (type === "manufacturerCode") {
      return this.app.text.import.manufacturerCode;
    }
    if (type === "warehouseGroup") {
      return this.app.text.import.warehouseGroupsDefinition;
    }
    return this.app.getText(type + "." + type);
  }

  getFieldLabel(type: any, id: any) {
    if (this.app.import.type === "assembly") {
      type = "part";
    }
    if (
      this.app.customers.expectCurrent === Customer.DB &&
      (this.app.import.type === "vehicleResponsible" ||
        this.app.import.type === "impact")
    ) {
      const responsibles = new Responsibles();
      if (Object.keys(responsibles).find((field) => field == id)) {
        return this.app.field.getLabel("responsibles" + "." + id);
      } else {
        return this.app.field.getLabel(this.app.import.type + "." + id);
      }
    } else {
      return this.app.field.getLabel(type + "." + id);
    }
  }

  isAssemblyBomColumn(id: string): boolean {
    const assemblyImportColumns: string[] =
      (
        this.app.settings.import.additionalInfo as {
          assemblyImportColumns?: string[];
        }
      ).assemblyImportColumns ?? [];

    return (
      this.app.import.type === "assembly" &&
      id !== "usedInPartNumber" &&
      id !== "partNumber" &&
      assemblyImportColumns.includes(id)
    );
  }

  getAssemblyBomValue(doc: any, partNumber: string, field: string): any {
    const entry = getBomPartEntry(doc.parts?.[partNumber]);
    return field === "usedInQuantity"
      ? entry.quantity
      : ((entry as any)[field] ?? "");
  }

  onClear() {
    this.app.import.docs = [];
    this.app.import.step = "first";
    this.showDataTypeDropdown = false;
    this.showExcelFileBtn = true;
    this.excelSelected = false;
    this.jsonSelected = false;
  }
}
